import "./articlecard.scss";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

export interface IArticleCard {
    image:string
    text:string
    link:string
}

const ArticleCard = ({image,text,link}:IArticleCard) => {
    return(
        <div className="Article-Card">
            <img src={image} alt="logo" className="img-fluid"/>
            <p className="py-4 Article-Card-Text">{text}</p>
            <div className="text-start">
                <a href={link} className="Article-Link nav-link red-text">
                    مشاهده &nbsp;&nbsp;&nbsp; <ArrowBackIosIcon />
                </a>
            </div>
        </div>
    );
}

export default ArticleCard;